/**
 * Display helpers para cotizaciones.
 *
 * `Venta Varios` es el nombre interno del producto misc del POS
 * (`products.is_misc = true`, sku `__VARIOS__`, `is_public = false`).
 * Cuando una cotización referencia ese producto, el comercio no debería ver
 * jerga interna: se muestra el genérico 'Servicio' (UX audit #1467).
 * Es solo mapping de display — el nombre real del producto no se toca.
 */
export const MISC_PRODUCT_INTERNAL_NAME = 'Venta Varios';
export const QUOTE_SERVICE_FALLBACK = 'Servicio';

export function quoteServiceDisplayName(
  productName: string | null | undefined,
  isMisc?: boolean | null,
): string {
  const trimmed = productName?.trim() ?? '';
  if (isMisc === true || trimmed === MISC_PRODUCT_INTERNAL_NAME) {
    return QUOTE_SERVICE_FALLBACK;
  }
  return trimmed || QUOTE_SERVICE_FALLBACK;
}
